import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-14">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              最新文章
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门资讯与实用指南
            </h2>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 008pg国际`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-md">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  <span className="text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                    阅读更多 →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}